import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Component, OnInit, Inject,AfterViewInit, ViewChild, ɵConsole } from '@angular/core';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { Router } from '@angular/router';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs';

import { nkServices } from '../../servicios/app.nkservicios.services';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar'; 
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { HashKeyServices } from '../../servicios/app.hashkey.services';
import { AppUtilService } from '../../servicios/app.util.service';
import { AtributosService } from '../../servicios/atributos.service';
import { ToastNotificationService } from '../../servicios/toast-notification.service';
import { FormmMsgComponent } from '../formm-msg/formm-msg.component';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-form-login',
  templateUrl: './form-login.component.html',
  styleUrls: ['./form-login.component.css']
})
export class FormLoginComponent implements OnInit {
  hide = true;
  nombre:any;
  forma:FormGroup;
  accion:any;
  des:any;
  logo:any;
  txt_l_1:any;
  txt_l_2:any;
  txt_l_3:any;
    constructor( 
            private servicio:nkServices,
            private fb:FormBuilder,
            private dialog: MatDialog,
            private hashkey:HashKeyServices,
            private util:AppUtilService,
            private atrb:AtributosService,
            private router:Router,
            private notifi:ToastNotificationService,
            private dialogRef: MatDialogRef<FormLoginComponent>,
      ///en el injectable llega la informacion del metodo padre en data
      @Inject(MAT_DIALOG_DATA) private data: any) {
        this.getParametrosApp();
        console.log(data, 'primero');
          this.accion = data.accion;
        this.forma = fb.group({
          'nom_usuario': ['',[Validators.required]],
          'pass_usuario': ['',[Validators.required]],
          'operacion': [''],
          'token': [hashkey.encrypt(atrb.TOKEN)],
        });
      }
    ngOnInit(){
          
    }
    async getParametrosApp(){
      try {
        /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
        let valor = {
          termino: await this.atrb.DEF.toUpperCase(),
          cod_app : await this.hashkey.encrypt(environment.path_token),
          cod_empresa : await localStorage.getItem('cod_empresa'),
          api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
        }
        const response = await this.servicio.ApiResthttp(valor).toPromise();
        let img_val;
        for (const i in response) {
          img_val = response[i].constante_app.split('_');
          if (img_val[0].toUpperCase() === await this.atrb.IMG.toUpperCase()) {
            response[i].img = environment.path_storage+response[i].val_def;
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.IMG_LOG_1.toUpperCase()) {
              this.logo = response[i].img;
            }
          }
          if (img_val[0].toUpperCase() === await this.atrb.TXT.toUpperCase()) {
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_L_1.toUpperCase()) {
              this.txt_l_1 = response[i].val_def;
            }
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_L_2.toUpperCase()) {
              this.txt_l_2 = response[i].val_def;
            }
            if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TXT_L_3.toUpperCase()) {
              this.txt_l_3 = response[i].val_def;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
   async login(){
        try {
          let pass = await this.hashkey.encrypt(this.forma.value.pass_usuario);
          this.forma.patchValue({
            pass_usuario:pass,
            operacion: await this.atrb.LOGIN
          });
        this.dialogRef.close(this.forma.value);
        } catch (error) {
          console.log(error);
        }
    }
   async recuperarPass(){
      try {
        let valor = {operacion:await this.atrb.RECUPERACION.recuperar_pass}
        this.dialogRef.close(valor);
      } catch (error) {
        console.log(error);
          await this.util.cerrarSpinner();
          await this.notifi.customToastNotification(error.error.message);
      }
    }
    async cerrarmodal(){
      try {
        let accion = 'salir';
        let dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:'',
                accion:accion},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if (result != 'cerrar') {
            await this.util.cerrarSpinner();
            this.forma.patchValue({
              operacion: await this.atrb.CERRAR
            });
            this.dialogRef.close(this.forma.value);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        console.log(error);
     }
    }
    async modalRegistro(){
      try {
        let accion = '';
        let dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:'',
                accion:accion},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if (result !== await this.atrb.CERRAR.toUpperCase()) {
            await this.util.cerrarSpinner();
            this.forma.patchValue({
              operacion: await this.atrb.REGISTRO
            });
            this.dialogRef.close(this.forma.value);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        console.log(error);
     }
    }
}
